import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const Container = createComponent('div', {
  className:
    'mx-auto mt-4xl flex max-w-[1144px] flex-col items-center justify-center gap-4xl px-2xl'
});

export const CategoryWrapper = createComponent<
  ElementWithProps & { cardCount: number }
>('div', props => ({
  className: cx(
    'grid w-full grid-cols-1 gap-y-[42px] m:grid-cols-2 m:gap-x-xl m:gap-y-3xl',
    props.cardCount < 3 ? 'm:flex m:w-2/3 m:justify-around' : 'm:grid-cols-3'
  )
}));
